import React, { FC, useCallback, useContext } from "react";
import { ScreenProps } from "../typings";
import { MarkdownView as IMarkdownView } from "@data-root/types";
import { Button, Typography } from "antd";
import { Layout } from "antd";
import { useAppContext, useClientContext } from "@data-root/react";

const { Text } = Typography;
const { Content } = Layout;

export const MarkdownView: FC<ScreenProps<IMarkdownView>> = ({ view }) => {
  const { options } = view;
  const { markdown } = options;

  const { appId } = useAppContext();
  const { core } = useClientContext();

  const onClick = useCallback(async () => {
    const serviceUuid = "91bad492-b950-4226-aa2b-4ede9fa42f59";
    const idCharacteristicUuid = "cba1d466-344c-4be3-ab3f-189f80dd7518";
    const weightCharacteristicUuid = "ca73b3ba-39f6-4ab3-91ae-186dc9577d99";

    try {
      const characteristics = await core.ble.connect(serviceUuid);
      if (!characteristics) throw new Error("No characteristics found");

      const idCharacteristic =
        await core.ble.service?.getCharacteristic(idCharacteristicUuid);
      const weightCharacteristic = await core.ble.service?.getCharacteristic(
        weightCharacteristicUuid
      );

      core.ble.startNotifications(
        idCharacteristic,
        (data) => {
          console.log(`ID: ${data}`);
        },
        "string"
      );

      core.ble.startNotifications(
        weightCharacteristic,
        (data) => {
          console.log(`Weight: ${data}`);
        },
        "string"
      );
    } catch (error) {
      console.error(error);
    }
  }, [core.ble]);

  return (
    <Layout>
      <Content>
        {/* <Text>{markdown}</Text> */}
        <Button
          type="primary"
          onClick={() => {
            throw new Error("oof");
            onClick();
          }}
        >
          Test
        </Button>
      </Content>
    </Layout>
  );
};
